









import { Component, Vue, Prop } from "vue-property-decorator";
import { v4 as uuidv4 } from "uuid";

@Component
export default class PaymentRequestButton extends Vue {
  public name = "PaymentRequestButton";

  @Prop({ default: () => uuidv4() })
  public id!: string;

  @Prop()
  public tooltipLabel: any;
}
